import { render, staticRenderFns } from "./Singpass.vue?vue&type=template&id=49c91096&scoped=true&"
import script from "./Singpass.vue?vue&type=script&lang=js&"
export * from "./Singpass.vue?vue&type=script&lang=js&"
import style0 from "./Singpass.vue?vue&type=style&index=0&id=49c91096&prod&lang=scss&scoped=true&"
import style1 from "./Singpass.vue?vue&type=style&index=1&id=49c91096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c91096",
  null
  
)

export default component.exports